import React, { useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

export interface HFinputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  register?: UseFormRegisterReturn;
  error?: string;
  height?: number;
}

const HFinput = ({
  className,
  register,
  label,
  error,
  height = 50,
  type = 'text',
  ...rest
}: HFinputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const py = (height - 26) / 2;
  const size = `w-full h-auto px-[10px] py-[${py}px] text-md mb-6`;
  const design = 'bg-white rounded transition-colors';
  const text = 'overflow-hidden text-ellipsis';
  const border = error
    ? 'border border-red-500 focus:outline-none focus:border-red-500'
    : 'border border-gray5 focus:outline-none focus:border-purple5';

  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  return (
    <div className="relative w-full">
      <div className={`mb-2 text-sm leading-snug ${!label && 'hidden'}`}>
        {label}
      </div>
      <div className="relative">
        <input
          type={inputType}
          className={`${size} ${design} ${border} ${text} ${className} ${isPassword ? 'pr-12' : ''}`}
          {...rest}
          {...register}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 transform text-gray-600 focus:outline-none"
            style={{ top: `${py + 13}px` }}
          >
            {showPassword ? (
              <EyeIcon className="h-5 w-5" />
            ) : (
              <EyeSlashIcon className="h-5 w-5" />
            )}
          </button>
        )}
      </div>

      {error && (
        <div className="absolute bottom-1 left-0 text-xs text-red-500">
          {error}
        </div>
      )}
    </div>
  );
};

export default HFinput;
